var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsletter = function SvgNewsletter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2B3C1",
    d: "M54.52 26.996H25.923a4.973 4.973 0 0 0-4.973 4.973v8.62a4.97 4.97 0 0 0 1.913 3.92c4.885 3.808 12.182 9.485 12.953 10.036 1.101.786 2.203 1.048 4.13 1.048 1.542 0 3.028-.7 3.579-1.048l13.906-10.04a4.97 4.97 0 0 0 2.062-4.033v-8.503a4.973 4.973 0 0 0-4.973-4.973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M47.248 34.881c.593.58.608 1.537.035 2.137l-8.24 8.629-5.795-5.566a1.524 1.524 0 0 1-.055-2.136 1.48 1.48 0 0 1 2.109-.056l3.65 3.506 6.186-6.478a1.48 1.48 0 0 1 2.11-.036",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2B3C1",
    fillRule: "evenodd",
    d: "M44.786 34.595a1.945 1.945 0 0 1 2.773-.047 1.99 1.99 0 0 1 .046 2.79l-8.564 8.968-6.132-5.89a1.99 1.99 0 0 1-.072-2.79 1.945 1.945 0 0 1 2.772-.074l3.313 3.182zm2.12.619a1.013 1.013 0 0 0-1.446.025l-6.51 6.816-3.987-3.83a1.013 1.013 0 0 0-1.446.038 1.06 1.06 0 0 0 .038 1.48l5.457 5.243 7.919-8.291a1.06 1.06 0 0 0-.025-1.481",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M56.55 26.076a1.554 1.554 0 0 1-1.434-1.666l.14-1.86a1.554 1.554 0 1 1 3.1.233l-.14 1.86a1.554 1.554 0 0 1-1.666 1.433M59.168 27.777a1.554 1.554 0 0 1 .164-2.192l1.414-1.216a1.554 1.554 0 1 1 2.027 2.356l-1.414 1.216c-.65.56-1.632.486-2.191-.164M60.726 30.417a1.554 1.554 0 0 1 1.666-1.433l1.86.14a1.554 1.554 0 0 1-.233 3.1l-1.86-.14a1.554 1.554 0 0 1-1.433-1.667",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.82 30.824 27.863 21.428a8.39 8.39 0 0 0 10.138.071l28.812-21.518-28.609-19.763a8.39 8.39 0 0 0-9.537-.002zm-1.233-1.037L34.604 9.76a9.95 9.95 0 0 1 11.304.003l28.965 20.01c.7.483.718 1.51.037 2.019L45.751 53.569a9.95 9.95 0 0 1-12.015-.085L5.535 31.796a1.243 1.243 0 0 1 .052-2.009",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.376 30.105h-.705c-.37 0-.671.26-.671.58V72.42c0 .32.3.58.671.58h69.12c.37 0 .671-.26.671-.58V30.684c0-.32-.3-.58-.67-.58h-.76v1.16h.088v40.577H6.342V31.264h.034z",
    clipRule: "evenodd"
  })));
};
export default SvgNewsletter;